import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick';

function OurSlider({ donation }) {
    const [value, setValue] = useState(16);

    const handleChange = (e) => {
        setValue(e.target.value);
    };

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3.6,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '8%',
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    centerPadding: '10%',
                    centerMode: true,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '10%',
                    centerMode: true,
                },
            },
        ],
    };



    return (
        <>
            <Slider {...settings}>
                {donation?.map((e, i) => {
                    const endDate = new Date(e?.Campaign?.CampaignEndDate);
                    const today = new Date();
                    const timeDiff = endDate - today;
                    const daysLeft = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

                    return (
                        <div key={i} className="px-2">
                            <Link to={`/donation-details/${e?.Campaign?._id}`}>
                                <img src={e?.Campaign?.Image} className='w-full h-[185px] object-cover rounded-t-[16px]' alt="" />
                                <div className='rounded-b-lg-[16px] p-[12px] bg-[#FDFDFD]' style={{ boxShadow: "0px 0px 4px 0px #00000014" }}>
                                    <div className="flex items-center gap-[4px] ">
                                        <p className="font-[400] font-manrope text-[16px] text-[#4D4D4D]">{e?.Campaign?.CampaignCategory}</p>
                                        <img src="/assets/home/blue-tick.png" alt="" />
                                    </div>
                                    <p className="font-[700] text-[20px] font-manrope text-[#333333] pb-[4px]">
                                        {e?.Campaign?.CampaignName}
                                    </p>
                                    <input
                                        type="range"
                                        id="range"
                                        min="0"
                                        max={e?.Campaign?.TotalRequiredDonation}
                                        value={e?.Campaign?.ReceivedDonation}
                                        className="w-full accent-[#FF6000]"
                                    />
                                    <div className='flex justify-between items-center'>
                                        <div>
                                            <p className="font-[400] font-manrope text-[11px] text-[#666666]">Raised</p>
                                            <h6 className="font-[700] font-manrope text-[20px] text-[#141414]">{e?.Campaign?.TotalRequiredDonation}</h6>
                                        </div>
                                        <div>
                                            <p className="font-[400] font-manrope text-right text-[11px] text-[#666666]">Days left</p>
                                            <h6 className="font-[700] font-manrope text-right text-[20px] text-[#141414]">
                                                {daysLeft > 0 ? daysLeft : 'Ended'}
                                            </h6>
                                        </div>
                                    </div>
                                    <button className='font-[600] text-[18px] font-manrope w-full text-center text-[#FFFFFF] rounded-[6px] mt-[6px] py-[12.5px]' style={{ background: "linear-gradient(90deg, #FF6000 0%, #F68B29 100%)" }}>
                                        Donate
                                    </button>
                                </div>
                            </Link>
                        </div>
                    );
                })}
            </Slider>
        </>
    )
}

export default OurSlider